import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';
import { documentationActions } from '../../actions/constant';

const {
  REQUEST_DAILY_SESSION_NOTES_SIGN,
  SUCCESS_DAILY_SESSION_NOTES_SIGN,
  FAILURE_DAILY_SESSION_NOTES_SIGN,
  LOADER_DAILY_SESSION_NOTES_SIGN,
  RESET_DAILY_SESSION_NOTES_SIGN,
} = documentationActions;

function* checkSignatureDailyNotes(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADER_DAILY_SESSION_NOTES_SIGN });

    const response = yield call(dailySessionNotesService.checkDailyNotSign, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_DAILY_SESSION_NOTES_SIGN, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_DAILY_SESSION_NOTES_SIGN, payload: error });
  }
}

function* checkSignatureDailyNotesSaga() {
  yield takeEvery(REQUEST_DAILY_SESSION_NOTES_SIGN, checkSignatureDailyNotes);
}

export default checkSignatureDailyNotesSaga;
